module.exports = __webpack_public_path__ + "front/img/p2_2.9565dc1a.png";